(function() {
  'use strict';

  function filterSelection(filter) {
    var columns = document.getElementsByClassName('column');
    var isTrentino = filter.indexOf('trentino') > -1 || filter.indexOf('alto') > -1 || filter.indexOf('südtirol') > -1;

    for (var i = 0; i < columns.length; i++) {
      if (filter === 'all') {
        columns[i].style.display = 'block';
      } else {
        var cls = columns[i].className;
        var match = cls.indexOf(filter) > -1;

        // display=block to both "alto" and "trentino" class when region selected
        if (isTrentino && (cls.indexOf('alto') > -1 || cls.indexOf('trentino') > -1)) {
          match = true;
        }

        columns[i].style.display = match ? 'block' : 'none';
      }
    }
  }

  function rearrangeLayout() {
    var main = document.querySelector('#producer-content-area .main');
    if (!main) return;
    var intro = document.getElementById('producer-intro');
    if (!intro) return;
    var els = main.querySelectorAll(':scope > h2, :scope > h4, :scope > p');
    els.forEach(function (el) { intro.appendChild(el); });
    var btnContainer = main.querySelector('#myBtnContainer');
    if (btnContainer) { intro.appendChild(btnContainer); }
  }

  function init() {
    rearrangeLayout();
    filterSelection('all');

    var currentMapRegion = null;

    var showAllBtn = document.querySelector('#myBtnContainer .btn');
    if (showAllBtn) {
      showAllBtn.addEventListener('click', function() {
        filterSelection('all');
        currentMapRegion = 'all';

        var activeBtn = document.querySelector('.btn.active');
        if (activeBtn) activeBtn.classList.remove('active');
        this.classList.add('active');

        var svgElement = document.querySelector('#italy-svg-container svg');
        if (svgElement) {
          svgElement.querySelectorAll('path.region-selected').forEach(function (p) {
            p.classList.remove('region-selected');
          });
        }
      });
    }

    // Attach to window so the map script can call it
    window.onRegionClick = function (regionName) {
      var mapValue = regionName.toLowerCase();
      var filterClass = mapValue;

      // Map names to HTML column classes for regions that don't directly match
      if (mapValue === 'emilia-romagna') filterClass = 'emilia';
      if (mapValue === 'südtirol' || mapValue === 'trentino' || mapValue === 'trentino-alto adige') filterClass = 'alto,trentino';

      var svgElement = document.querySelector('#italy-svg-container svg');

      currentMapRegion = mapValue;

      // Force the region to remain visually selected, countering any default toggle-off behavior
      if (svgElement) {
        svgElement.querySelectorAll('path[id]').forEach(function (path) {
          var rName = (window.__regionMapping && window.__regionMapping[path.id]) || path.getAttribute('name');
          if (rName && rName.toLowerCase() === mapValue) {
            path.classList.add('region-selected');
          }
        });
      }

      filterSelection(filterClass);
      var currentBtnContainer = document.getElementById('myBtnContainer');
      if (currentBtnContainer) {
        var activeBtn = currentBtnContainer.querySelector('.btn.active');
        if (activeBtn) activeBtn.classList.remove('active');
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
